import React from 'react';
import { TextFieldProps } from 'mui-rff';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';
import Input from '../Input';

import styles from './DigitInput.module.css';

const only1Characters = onlyNCharacters(1);

const DigitInput = ({ fieldProps, ...props }: TextFieldProps) => (
  <Input
    id="outlined-basic"
    type="tel"
    variant="outlined"
    className={styles.digitInput}
    fieldProps={{
      format: (value: string) => only1Characters(onlyNumbers(value)),
      parse: (value: string) => only1Characters(onlyNumbers(value)),
      ...fieldProps,
    }}
    {...props}
  />
);

export default DigitInput;
